import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { collections } from '../data/mock';

export const Collections = () => {
  const getCollectionSlug = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
  };

  return (
    <section id="collections" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light tracking-tight text-stone-900 mb-6">
            Our Collections
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto font-light leading-relaxed">
            Curated selections that transform functional fixtures into design statements
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {collections.map((collection) => (
            <div
              key={collection.id}
              className="group cursor-pointer"
            >
              <div className="relative aspect-square bg-stone-100 overflow-hidden mb-6">
                <img
                  src={typeof collection.images[0] === 'string' ? collection.images[0] : collection.images[0].src}
                  alt={collection.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              
              <div className="space-y-4">
                <h3 className="text-2xl font-light tracking-tight text-stone-900">
                  {collection.name}
                </h3>
                <p className="text-stone-600 leading-relaxed">
                  {collection.description}
                </p>
                <div className="pt-2">
                  <Link to={`/collection/${getCollectionSlug(collection.name)}`}>
                    <Button
                      className="bg-stone-900 hover:bg-stone-800 text-stone-50 px-6 py-3 text-sm tracking-widest transition-all duration-300"
                    >
                      VIEW COLLECTION
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};